import React from 'react';
import { string } from 'prop-types';
import { Col } from '@thd-olt-component-react/grid';

export const ProductInfo = ({ title, info }) => {
  return (
    <Col>
      <span className="u__bold">
        {title}
        #:
      </span>
      {' '}
      {info}
    </Col>
  );
};

ProductInfo.displayName = 'ProductInfo';

ProductInfo.propTypes = {
  title: string,
  info: string
};

ProductInfo.defaultProps = {
  title: '',
  info: ''
};
